export default function preserveInputFocus(event) {
  event?.preventDefault?.();
}
